module.exports = __webpack_public_path__ + "static/media/Pewters Avenue 4.848c915e.jpg";